<template>
    <div class="MAM_rateInfo">
        <el-dialog :visible="rateIsShow" width="40%" @close="handleClose">
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                    <span
                        style="font-weight:700;font-size:13px"
                    >{{publickData.brandName}}</span>
                </div>
                <el-form ref="form" :inline="true">
                    <template v-for="(titleItem,titleIndex) in baseTabContent">
                        <!-- 小标题 -->
                        <div :key="titleIndex">
                            <div class="type_title">{{titleItem.title}}</div>
                            <el-form-item
                                v-for="(item,index) in titleItem.list"
                                :label="item.title"
                                :key="index"
                            >
                                <el-input
                                    v-model="item.value"
                                    size="medium"
                                    :placeholder="item.sub_title"
                                ></el-input>
                            </el-form-item>
                            <el-divider></el-divider>
                        </div>
                    </template>
                    <el-button
                        :loading="btnLoading"
                        @click="handleSubmit()"
                        type="primary"
                        style="font-size:12px"
                    >提 交</el-button>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_rateInfo",
    props: {
        rateIsShow: {
            type: Boolean,
            default: false
        },
        idsArray:{
            type:Array,
            default: function () {
                return  [];
            }
        },
        brandidsArray:{
            type:Array,
            default: function () {
                return  [];
            }
        },
        isbindArray:{
            type:Array,
            default: function () {
                return  [];
            }
        },
        useridArray:{
            type:Array,
            default: function () {
                return  [];
            }
        },
    },
    data() {
        return {
            publickData: {
                brandName:'',
            },
            baseTabContent: [], //基础费率 -tab内容
            OldData: [], //基础费率 - 旧数据(对比使用)
            btnLoading: false,
            level: sessionStorage.getItem('level'),
            admin_id: sessionStorage.getItem('admin_id')
        }
    },
    mounted() {
      this.getBaseRate();
    },
    methods: {
        handleSubmit() {
            this.btnLoading = true;
            var oldata=this.OldData;
            let reqList = []; //请求的list
            this._.forEach(this.baseTabContent, (v, i) => {
                let child = [];
                let oldata1 = oldata[i];
                this._.forEach(v.list, (item, index) => {
                    let oldata2 = oldata1.list[index];
                    if (item.value != '') {
                        if (oldata2.value != item.value) {
                                reqList.push(this.baseTabContent[i]);
                        }
                    }
                })
            });
            this.$api.post('terminal/updateTerminalRate', {data:reqList,terminal_id:this.idsArray}, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.$emit('infoClose');
                    this.btnLoading = false;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 5000
                    })
                    this.btnLoading = false;
                }
            })
        },
        getBaseRate() { //获取基础费率
            this.$api.post('terminal/getTerminalRateInfo', { terminal_id:this.idsArray[0]}, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.OldData = this._.cloneDeep(data.t0);
                    this.publickData.brandName=data.brand_name;
                    this.baseTabContent = data.t0;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleClose() {
            this.$emit('infoClose');
        }
    }
}
</script>

<style scoped lang="scss">
.MAM_rateInfo {
    ::v-deep .el-form-item__label {
        font-size: 12px;
        font-weight: 700;
    }
    ::v-deep .el-input__inner {
        width: 150px;
    }
    ::v-deep .el-dialog {
        height: 80%;
        .el-dialog__body {
            height: 82%;
            overflow: auto;
        }
    }
    .type_title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
    }
}
</style>
